import {
  Autocomplete,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  Carousel,
  CarouselItem,
  Cascader,
  CascaderPanel,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Image,
  Input,
  InputNumber,
  Loading,
  Menu,
  MenuItem,
  MenuItemGroup,
  Message,
  MessageBox,
  Option,
  OptionGroup,
  Pagination,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Rate,
  Row,
  Select,
  Slider,
  Step,
  Steps,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Timeline,
  TimelineItem,
  Tooltip,
  Upload
} from 'element-ui'
import infiniteScroll from 'vue-infinite-scroll'

export default (Vue) => {
  Vue.use(infiniteScroll)
  Vue.component(Checkbox.name, Checkbox)
  Vue.component(CheckboxGroup.name, CheckboxGroup)
  Vue.component(Popover.name, Popover)
  Vue.component(Pagination.name, Pagination)
  Vue.component(Dialog.name, Dialog)
  Vue.component(Input.name, Input)
  Vue.component(Radio.name, Radio)
  Vue.component(RadioGroup.name, RadioGroup)
  Vue.component(Switch.name, Switch)
  Vue.component(Option.name, Option)
  Vue.component(OptionGroup.name, OptionGroup)
  Vue.component(Form.name, Form)
  Vue.component(FormItem.name, FormItem)
  Vue.component(Dropdown.name, Dropdown)
  Vue.component(DropdownMenu.name, DropdownMenu)
  Vue.component(DropdownItem.name, DropdownItem)
  Vue.component(Breadcrumb.name, Breadcrumb)
  Vue.component(BreadcrumbItem.name, BreadcrumbItem)
  Vue.component(Menu.name, Menu)
  Vue.component(Submenu.name, Submenu)
  Vue.component(MenuItem.name, MenuItem)
  Vue.component(MenuItemGroup.name, MenuItemGroup)
  Vue.component(Button.name, Button)
  Vue.component(Row.name, Row)
  Vue.component(Col.name, Col)
  Vue.component(Tag.name, Tag)
  Vue.component(Collapse.name, Collapse)
  Vue.component(CollapseItem.name, CollapseItem)
  Vue.component(Tooltip.name, Tooltip)
  Vue.component(Progress.name, Progress)
  Vue.component(Card.name, Card)
  Vue.component(Divider.name, Divider)
  Vue.component(Image.name, Image)
  Vue.component(RadioButton.name, RadioButton)
  Vue.component(CheckboxButton.name, CheckboxButton)
  Vue.component(Select.name, Select)
  Vue.component(Cascader.name, Cascader)
  Vue.component(CascaderPanel.name, CascaderPanel)
  Vue.component(DatePicker.name, DatePicker)
  Vue.component(Upload.name, Upload)
  Vue.component(Slider.name, Slider)
  Vue.component(Rate.name, Rate)
  Vue.component(Drawer.name, Drawer)
  Vue.component(Autocomplete.name, Autocomplete)
  Vue.component(Carousel.name, Carousel)
  Vue.component(CarouselItem.name, CarouselItem)
  Vue.component(Table.name, Table)
  Vue.component(TableColumn.name, TableColumn)
  Vue.component(Step.name, Step)
  Vue.component(Steps.name, Steps)
  Vue.component(InputNumber.name, InputNumber)
  Vue.component(Timeline.name, Timeline)
  Vue.component(TimelineItem.name, TimelineItem)
  Vue.use(Tabs)
  Vue.use(TabPane)
  Vue.use(Loading)
  Vue.prototype.$message = Message
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$loading = Loading
}
